const INTERNAL_ERROR_PATTERNS = [
  /column ".+" of relation/i,
  /relation ".+" does not exist/i,
  /queryfailederror/i,
  /syntax error at/i,
  /econnrefused/i,
  /unexpected token/i,
]

function isInternalErrorMessage(message: string): boolean {
  return INTERNAL_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

function isUserFacingApiMessage(message: string, status?: number): boolean {
  if (status !== undefined && status >= 500) {
    return false
  }

  return !isInternalErrorMessage(message)
}

/** Extract a user-facing message from ScrubstrApiQueryService error responses. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'data' in error) {
    const response = error as { status?: number; data?: { message?: string } }
    const message = response.data?.message

    if (message && isUserFacingApiMessage(message, response.status)) {
      return message
    }
  }

  if (error instanceof Error && error.message && isUserFacingApiMessage(error.message)) {
    return error.message
  }

  return fallback
}
